import React from 'react';
import './ui.scss';

const VARIANT_CLASS = {
  primary: 'builder-ui-btn--primary',
  secondary: 'builder-ui-btn--secondary',
  ghost: 'builder-ui-btn--ghost',
  danger: 'builder-ui-btn--danger',
};

export const Button = ({
  children,
  variant = 'secondary',
  size,
  icon,
  className = '',
  type = 'button',
  ...props
}) => {
  const classes = [
    'builder-ui-btn',
    VARIANT_CLASS[variant] || VARIANT_CLASS.secondary,
    size === 'sm' ? 'builder-ui-btn--sm' : '',
    icon && !children ? 'builder-ui-btn--icon' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={classes} {...props}>
      {icon}
      {children}
    </button>
  );
};

export default Button;
